"use client";

import Button from "./Button";
import FA_LANG from "@/assets/locale/fa";
import React, { useEffect } from "react";
import icons from "@/assets/icons";

type InitProps = {
  items: SelectItem[];
  selectedItem?: SelectItem;
  placeholder: string;
  containsNull?: boolean;
  onChange?: Function;
  title: string;
  error?: boolean;
  errorMessage?: string;
  isMandatory?: boolean;
  icon?: JSX.Element;
  iconWidth?: string;
  iconHeight?: string;
  titleInside?: boolean;
  styleClass?: string;
  dropDownHeight?: string;
  open?: boolean;
  openCallBack?: Function;
};

export default function Dropdown({
  items,
  selectedItem,
  placeholder,
  containsNull,
  onChange,
  title,
  error,
  errorMessage,
  isMandatory,
  icon,
  iconWidth,
  iconHeight,
  titleInside,
  styleClass,
  dropDownHeight,
  open,
  openCallBack,
}: InitProps) {
  const [openDropDown, setopenDropDown] = React.useState(false);

  useEffect(() => {
    if (open !== undefined) {
      setopenDropDown(open);
    }
  }, [open, items]);
  const toggleDropDown = () => {
    setopenDropDown(!openDropDown);
    if (openCallBack) openCallBack(!openDropDown);
  };
  const selectItem = (item?: SelectItem) => {
    setopenDropDown(!openDropDown);
    if (onChange) {
      onChange(item);
    }
  };

  return (
    <div className="flex flex-col w-full gap-1.5 h-full">
      {title.length > 0 ? (
        <div className="caption">
          <span>{title}</span>
          {isMandatory && <span className="text-error-text">*</span>}
        </div>
      ) : (
        <></>
      )}
      <div className="dropdown">
        <div
          className={`${
            openDropDown
              ? `basebutton ${dropDownHeight ? dropDownHeight : ""} open`
              : `basebutton ${dropDownHeight ? dropDownHeight : ""}`
          }`}
        >
          <Button
            styleClass={
              !title && placeholder
                ? " text-text-body flex items-center text-right"
                : selectedItem
                  ? "text-text-body flex items-center text-right"
                  : "text-text-caption2 flex items-center text-right"
            }
            handleClick={toggleDropDown}
            title={
              title.length > 0 && !selectedItem
                ? title
                : selectedItem
                  ? selectedItem.title
                  : placeholder
            }
            trailingIcon={openDropDown ? icons.arrow_up : icons.arrow_down}
            icon={icon}
            iconHeight={iconHeight}
            iconWidth={iconWidth}
            fullWidth={true}
            trailingIconStyle="absolute left-2 "
          />
        </div>
        {error && (
          <div className="text-error-text text-right text-[10px] font-medium leading-4 h-2.5">
            {error ? errorMessage : ""}
          </div>
        )}
        <div
          className={
            openDropDown
              ? "menu md:h-auto h-[150px] overflow-scroll "
              : "hidden "
          }
          tabIndex={0}
          onMouseLeave={() => setopenDropDown(false)}
        >
          {containsNull || items.length == 0 ? (
            <Button
              id={"0"}
              styleClass="menu-item text-right "
              title={FA_LANG.PLEASE_SELECT}
              handleClick={() => selectItem()}
              fullWidth={true}
            />
          ) : (
            <React.Fragment />
          )}
          {items.map((item) => (
            <Button
              key={item.id}
              id={item.id.toString()}
              styleClass={`menu-item text-right ${
                selectedItem && selectedItem.id === item.id
                  ? " bg-bg-cards "
                  : "  "
              } `}
              title={item.title}
              handleClick={() => selectItem(item)}
              fullWidth={true}
              trailingIcon={item.icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
